'use client'
import { NextPage } from 'next'
import dynamic from 'next/dynamic'

const RegisterContainer: NextPage = dynamic(
  async () => (await import('@/containers/auth')).RegisterContainer,
  {
    ssr: false,
  },
)

export default function RegisterPage() {
  return <RegisterContainer />
}
